import React from "react";
import { Container, Row, Col } from "reactstrap";
import styled from "styled-components";
import { Images } from "pickups-ui-library/styles/icons";
import { Loader } from "pickups-ui-library";
import imageCompressor from "utils/imageCompressor";

const ImageContainer = styled.div`
  width: 100%;
  position: relative;

  ${({ disableHover, loading }) =>
    !loading &&
    !disableHover &&
    `
  &:hover:after {
    content: "Remove";
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 0;
  }
 `}

  ${({ loading }) =>
    loading &&
    `
  &:after {
    content: "";
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 0;
  }
 `}
`;

const ImageManager = ({
  images,
  removeImage,
  addImages,
  loadingImages = [],
  disabled = false,
}) => (
  <>
    {images.length !== 0 && (
      <Container className="box p-4 mt-4 mb-4">
        <Row>
          {images.map((url, idx) => {
            const loading = loadingImages.some((imageIdx) => imageIdx === idx);

            return (
              <Col
                md={3}
                xs={12}
                style={{ display: "flex", alignItems: "center" }}
                className="my-2"
                key={idx}
              >
                <ImageContainer
                  disableHover={disabled}
                  loading={loading}
                  onClick={() => {
                    if (disabled || loading) return;

                    URL.revokeObjectURL(images[idx]);
                    removeImage(idx);
                  }}
                >
                  <img style={{ width: "100%" }} src={url} />
                  {loading && (
                    <Loader
                      width={32}
                      height={32}
                      color="#fff"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translateX(-50%) translateY(-50%)",
                        zIndex: 1,
                      }}
                    />
                  )}
                </ImageContainer>
              </Col>
            );
          })}
        </Row>
      </Container>
    )}
    {!disabled && (
      <label
        className="box p-4 position-relative d-flex align-items-center"
        style={
          images.length === 0
            ? { height: 350, flexDirection: "column", justifyContent: "center" }
            : {}
        }
      >
        <Images className="mr-4" style={{ width: 100 }} />
        Click here or drag and drop to upload an image
        <input
          type="file"
          accept="image/*"
          multiple
          style={{
            opacity: 0,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          onChange={async (e) => {
            const images = await Promise.all(
              Array.from(e.target.files).map(async (file) => {
                return await imageCompressor(file, {
                  toastErrorOptions: {
                    message:
                      "Sorry, we couldn't compress the image, it will take more time to upload",
                    autoClose: 8000,
                  },
                });
              })
            );
            addImages(images);
          }}
        />
      </label>
    )}
  </>
);

export default ImageManager;
